<template>
  <section>
    <div class="container">
      <div class="jumbo jumbo--md">
        <div class="row">
          <div class="col-m-8">
            <article class="article mb-24">
              <h3>Производство оборудования</h3>
              <p>Полный цикл услуг по производству и запуску интерактивного оборудования - проектирование, производство, сборка, установка, написание программного обеспечения для нужд клиента, технического сопровождение и поддержка в процессе эксплуатации.</p>
            </article>
          </div>
        </div>
        <div class="row mt-40">
          <div class="col-m-4">
            <router-link to="/equipment/kiosks" class="icon-card">
              <div class="icon-card__icon">
                <SvgIcon name="kiosk" />
              </div>
              <div class="icon-card__title">Сенсорные киоски</div>
              <div class="icon-card__body">
                Для торговых и офисных центров, музеев и мероприятий
              </div>
           </router-link>
          </div>
          <div class="col-m-4">
            <router-link to="/equipment/kiosks-street" class="icon-card">
              <div class="icon-card__icon">
                <SvgIcon name="kiosk1" />
              </div>
              <div class="icon-card__title">Уличные киоски</div>
              <div class="icon-card__body">
                Для парков, музеев и туристических комплексов
              </div>
            </router-link>
          </div>
          <div class="col-m-4">
            <router-link to="/equipment/terminals" class="icon-card">
              <div class="icon-card__icon">
                <SvgIcon name="cashier" />
              </div>
              <div class="icon-card__title">Терминалы самообслуживания</div>
              <div class="icon-card__body">
                Для общепита, ритейла, спортивных площадок и промо-мероприятий
              </div>
            </router-link>
          </div>
          <div class="col-m-4">
            <router-link to="/equipment/tables" class="icon-card">
              <div class="icon-card__icon">
                <SvgIcon name="table" />
              </div>
              <div class="icon-card__title">Сенсорные столы</div>
              <div class="icon-card__body">
                От навигации по ТЦ до сложных интеграционных решений
              </div>
            </router-link>
          </div>
          <div class="col-m-4">
            <router-link to="/equipment/presentations" class="icon-card">
              <div class="icon-card__icon">
                <SvgIcon name="vr" />
              </div>
              <div class="icon-card__title">Презентационное оборудование</div>
              <div class="icon-card__body">
                AR решения для презентаций, голографические кубы и пирамиды
              </div>
            </router-link>
          </div>
          <div class="col-m-4">
            <a class="icon-card icon-card--link" href="/equip-request?type=custom">
              <div class="icon-card__icon">
                <SvgIcon name="add" />
              </div>
              <div class="icon-card__title">Другое оборудование</div>
              <div class="icon-card__body">
                Произведем любое решение - просто расскажите о задаче
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="text-center">
        <a @click.prevent="showModal('60898010a9f4a70044f2cbe3')" href="#" class="button">Расчет Стоимости</a>
      </div>
    </div>
    <Clients />
    <!-- <Equipment /> -->
    <VueFooter />
  </section>
</template>
<script>
const name = "Home"

import SvgIcon from '@/components/SvgIcon.vue'
import Clients from '@/components/Clients.vue'
import Equipment from '@/components/Equipment.vue'
import VueFooter from '@/components/VueFooter.vue'

export default {
  name,
  components: {
    Clients,
    VueFooter,
    SvgIcon,
    Equipment
  }
}

</script>
